import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Link, Text } from '@/ui'
import { useAnalyticsTrack } from '@/features/amplitude'
import { DetailsTooltip } from './DetailsTooltip'
import { TypographyStyles } from '@/styles'

export const CategorizationTooltip = ({
  openOnHover,
}: {
  openOnHover?: boolean
}) => {
  const track = useAnalyticsTrack()

  return (
    <DetailsTooltip
      label="Category"
      track={() => track('clicked category tooltip')}
      openOnHover={openOnHover}
    >
      <div
        onClick={(event) => {
          // The event bubbles up to the transaction table which would sort the table.  stop it here
          event.stopPropagation()
        }}
        role="presentation"
      >
        <Text variant={TypographyStyles.BODY_SM}>
          Heard&apos;s bookkeeping team categorizes transactions for you at a
          regular frequency.
        </Text>
        <br />
        <Text variant={TypographyStyles.BODY_SM} className="mb-2">
          If a transaction is in{' '}
          <span className="text-orange-500 font-semibold">orange</span>, this
          means Heard has categorized this transaction a certain way to ensure
          tax-compliance.
        </Text>
        <br />
        <Link
          href="https://support.joinheard.com/hc/en-us/articles/10547782596759-How-do-I-know-which-category-to-use-"
          newPage
        >
          View category glossary
          <Icon
            icon={faArrowRightLong}
            className="ml-2"
            size="sm"
            color="text-neutral-200"
          />
        </Link>
      </div>
    </DetailsTooltip>
  )
}
